import {
  GSTR1_REPORT_REQUEST,
  GSTR1_REPORT_SUCCESS,
  GSTR1_REPORT_FAILURE,
} from "../types/gstr1-report-types";

const initialState = {
  gstr1Report: {},
  loading: false,
  error: null,
};

const gstr1ReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GSTR1_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GSTR1_REPORT_SUCCESS: {
      return {
        ...state,
        gstr1Report: {...(action.payload || {})},
        loading: false,
        error: null
      };
    }
    case GSTR1_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default gstr1ReportReducer;
